<script>
  import { tick, afterUpdate, onMount } from "svelte";
  import Alerts from "../../Shared/Alerts.svelte";

  export let form,
    insurance = {},
    insuranceErrors,
    noInsurance = false;

  let insuranceEl, validInsurance;

  async function hasValidInsurance(valid) {
    validInsurance = valid;
    await tick();

    noInsurance = !valid;
    if (insuranceEl) {
      insuranceEl.scrollIntoView({
        behavior: "smooth",
      });
    }
  }

  function checkInsuranceErrors() {
    if (insuranceErrors.length) {
      validInsurance = true;
    }
  }

  onMount(() => {
    validInsurance = false;
    checkInsuranceErrors();

    if (insurance.required) {
      $form.insurance.start_date = insurance.start_date;
      $form.insurance.naic_number = insurance.naic_number;
      $form.insurance.policy_number = insurance.policy_number;
      $form.insurance.expiration_date = insurance.expiration_date;
      $form.insurance.company_name = insurance.company_name;
      validInsurance = true;
    }
  });

  afterUpdate(() => {
    checkInsuranceErrors();
  });

  $: if (insuranceErrors.length) {
    validInsurance = true;
  }
</script>

<div>
  {#if noInsurance}
    <Alerts
      errors={[
        "You must have valid and current liability insurance on this vehicle to renew your registration.",
      ]}
    />
  {/if}

  <p>Do you have valid and current liability insurance on this vehicle?</p>
  <button
    class="btn"
    class:btn-primary={validInsurance}
    class:btn-outline-primary={!validInsurance}
    on:click|preventDefault={() => hasValidInsurance(true)}
  >
    <i class="bi bi-check"></i>
    Yes
  </button>
  <button
    class="btn"
    class:btn-danger={!validInsurance}
    class:btn-outline-danger={validInsurance}
    on:click|preventDefault={() => hasValidInsurance(false)}
  >
    <i class="bi bi-x"></i>
    No
  </button>
  <div class="row" bind:this={insuranceEl}>
    {#if validInsurance && !noInsurance}
      <hr class="mb-2 mt-4" />
      <div class="col-6">
        <Alerts {form} errors={insuranceErrors} />
        <div class="my-3">
          <p>
            Please provide proof of your valid and current liability insurance
            coverage.
          </p>
        </div>
        <div class="row g-3">
          <div class="col-6">
            <div class="form-floating">
              <input
                type="text"
                class="form-control form-control-sm"
                id="naicNumber"
                placeholder="0000"
                class:is-invalid={$form.errors["insurance.naic_number"]}
                bind:value={$form.insurance.naic_number}
              />
              <label for="naicNumber" class="form-label">NAIC Number</label>
              {#if $form.errors["insurance.naic_number"]}
                <div class="invalid-feedback">
                  {$form.errors["insurance.naic_number"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating">
              <input
                type="text"
                class="form-control form-control-sm"
                id="policyNumber"
                placeholder="0000"
                class:is-invalid={$form.errors["insurance.policy_number"]}
                bind:value={$form.insurance.policy_number}
              />
              <label for="policyNumber" class="form-label">Policy Number</label>
              {#if $form.errors["insurance.policy_number"]}
                <div class="invalid-feedback">
                  {$form.errors["insurance.policy_number"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating">
              <input
                type="date"
                class="form-control form-control-sm"
                id="startDate"
                placeholder="0000"
                class:is-invalid={$form.errors["insurance.start_date"]}
                bind:value={$form.insurance.start_date}
              />
              <label for="startDate" class="form-label">Policy Start Date</label
              >
              {#if $form.errors["insurance.start_date"]}
                <div class="invalid-feedback">
                  {$form.errors["insurance.start_date"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating">
              <input
                type="date"
                class="form-control form-control-sm"
                id="expirationDate"
                placeholder="0000"
                class:is-invalid={$form.errors["insurance.expiration_date"]}
                bind:value={$form.insurance.expiration_date}
              />
              <label for="expirationDate" class="form-label"
                >Policy Expiration Date</label
              >
              {#if $form.errors["insurance.expiration_date"]}
                <div class="invalid-feedback">
                  {$form.errors["insurance.expiration_date"]}
                </div>
              {/if}
            </div>
          </div>
          <div class="col-12">
            <div class="form-floating">
              <input
                type="text"
                class="form-control form-control-sm"
                id="insCompany"
                placeholder="0000"
                class:is-invalid={$form.errors["insurance.company_name"]}
                bind:value={$form.insurance.company_name}
              />
              <label for="insCompany" class="form-label"
                >Insurance Company Name</label
              >
              {#if $form.errors["insurance.company_name"]}
                <div class="invalid-feedback">
                  {$form.errors["insurance.company_name"]}
                </div>
              {/if}
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>
</div>
